import React from 'react';
import { ISupportUser, ListItem, StringUtils } from '@localina/core';

interface IProps {
    user: ISupportUser;
    onClick: (user: ISupportUser) => void;
}

export const SupportUserListItem: React.FC<IProps> = (props) => {
    const handleClick = () => {
        props.onClick(props.user);
    };

    return (
        <ListItem
            title={StringUtils.combineStrings([props.user.lastName, props.user.firstName], ', ')}
            subtitle={props.user.email}
            onClick={handleClick}
        />
    );
};
